<div id="powerBIInputDiv" aria-label="PowerBIInput" aria-hidden="true" [style.height]="height"></div>
<div id="PowerBIInput" style="display: none;" aria-hidden="false" role="link"><a href="{{globalEmbedURL}}" aria-hidden="false">Link to the power bi report</a></div>
